var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.25,
    height: 20.842,
    viewBox: "0 0 17.25 20.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert_Icon_-_Active",
    "data-name": "Alert Icon - Active",
    transform: "translate(-1858.5 -85.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2845",
    "data-name": "Path 2845",
    d: "M15.563,13.254,15.04,12.6A7.053,7.053,0,0,1,13.5,8.205V7.031A5.347,5.347,0,0,0,9,1.753V1.125a1.125,1.125,0,0,0-2.25,0v.628a5.346,5.346,0,0,0-4.5,5.278V8.205A7.039,7.039,0,0,1,.708,12.6l-.524.654a.843.843,0,0,0,.659,1.371H14.906a.843.843,0,0,0,.658-1.371",
    transform: "translate(1859.251 87.104)",
    fill: "#dc1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Alert_Icon_-_Active-2",
    "data-name": "Alert Icon - Active",
    d: "M9.858,1.3V2.03a6.1,6.1,0,0,1,4.929,6.111V9.5a8.468,8.468,0,0,0,1.686,5.089l.574.757a1.021,1.021,0,0,1,.112,1.034.922.922,0,0,1-.832.553H.924a.922.922,0,0,1-.833-.553A1.023,1.023,0,0,1,.2,15.347l.574-.757A8.457,8.457,0,0,0,2.465,9.5V8.141A6.1,6.1,0,0,1,7.393,2.03V1.3a1.234,1.234,0,1,1,2.465,0M8.318,3.908a4.125,4.125,0,0,0-4,4.233V9.5A10.535,10.535,0,0,1,2.785,14.98H14.467A10.536,10.536,0,0,1,12.938,9.5V8.141a4.125,4.125,0,0,0-4-4.233ZM11.09,18.237a2.752,2.752,0,0,1-.72,1.844,2.455,2.455,0,0,1-1.744.761,2.4,2.4,0,0,1-1.745-.761,2.752,2.752,0,0,1-.72-1.844Z",
    transform: "translate(1858.5 85.685)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIconActive);
export default __webpack_public_path__ + "static/media/alert-icon-active.0155a8524bcd895919ab244cbea6c9d2.svg";
export { ForwardRef as ReactComponent };